import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';
import { CITY_PAGES } from '../../data/seoRetrofitData';

export default function LocationsIndexPage() {
  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="locations-index-page">
      <SEOHead
        title="Asset Finance Locations Australia | Flash Funding"
        description="Find city-specific asset finance support across Australia, including trucks, equipment, vehicles, and business loans."
        canonical="/locations"
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="locations-index-main-section">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-4">Asset Finance Locations Across Australia</h1>
        <p className="text-white/70 text-sm sm:text-base mb-8">Explore city pages for local market context, quote forms, and finance pathways.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="locations-index-grid">
          {CITY_PAGES.map((city) => (
            <Link
              key={city.path}
              to={city.path}
              className="rounded-2xl border border-purple-500/20 bg-navy-800/70 p-5 hover:border-purple-400/45"
              data-testid={`locations-index-link-${city.path.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}
            >
              <h2 className="text-xl font-semibold text-white mb-1">{city.path.replace('/locations/', '').replace(/-/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase())}</h2>
              <p className="text-white/60 text-sm">View local asset finance options and quote form.</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
